/**
 * Il freelance è disponibile **adesso**?
 *
 * `available_from` è una data di inizio, non un interruttore: un valore
 * qualsiasi significa "ha dichiarato una disponibilità", non "è disponibile".
 * La scheda pubblica mostrava il badge appena il campo era *truthy*, quindi un
 * freelance che si dichiara libero fra due mesi risultava disponibile oggi a
 * chiunque aprisse il link; il chip nell'header del proprio profilo, il
 * layout dell'area auth e il default del modale di disponibilità confrontavano
 * invece la data con `new Date()`, ciascuno con la propria copia inline.
 *
 * La regola vive **qui e solo qui**: i chiamanti sono `ProfileInfo` (badge
 * pubblico), `ProfileLayout` (chip header, due varianti), `auth/routes/layout`
 * e `AvailabilityModal` (valore iniziale di `is_available`). La metà
 * `weekly_hours` resta al chiamante: dice *quanto*, non *se*.
 *
 * Una data non parsabile vale `false`: davanti a un valore che non sappiamo
 * leggere, la risposta prudente è "non lo dichiariamo disponibile", non
 * "diciamo di sì".
 */
export const isAvailableNow = (
  availableFrom: Date | string | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!availableFrom) return false;

  const from =
    availableFrom instanceof Date ? availableFrom : new Date(availableFrom);
  if (Number.isNaN(from.getTime())) return false;

  return from.getTime() <= now.getTime();
};
